import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { LaboratorySampleForm } from '../model/form';
import { IContextSetting, NetworkConstants, getTimeFirebaseTimestamp, removeUndefined } from 'diwimamodelweb/lib';

@Component({
  selector: 'app-gamerecord-form-lab-samples',
  templateUrl: './gamerecord-form-lab-samples.component.html',
  styleUrl: './gamerecord-form-lab-samples.component.css'
})
export class GamerecordFormLabSamplesComponent {

  @Input() data: LaboratorySampleForm
  @Input() formBuilder: FormBuilder
  @Input() translateService: TranslateService
  @Output() submit = new EventEmitter<void>()

  labSampleForm: FormGroup
  dropdownType: IContextSetting[]
  dropdownStatus: IContextSetting[]
  dropdownLocation: IContextSetting[]

  ngOnInit(): void {
    this.dropdownLocation = this.data.contextSettings.get(NetworkConstants.SETTING_LAB_SAMPLE_LOCATION)?.values
    this.dropdownStatus = this.data.contextSettings.get(NetworkConstants.SETTING_LAB_SAMPLE_STATUS)?.values
    this.dropdownType = this.data.contextSettings.get(NetworkConstants.SETTING_LAB_SAMPLE_TYPE)?.values

    this.labSampleForm = this.formBuilder.group({
      materialID: [ {value: undefined, disabled:true} ],
      type: [{value: undefined, disabled:true} ],
      status: [ {value: undefined, disabled:true} ],
      currentLocation: [ {value: undefined, disabled:true} ],
      result: [ {value: undefined, disabled:true} ],
      comment: [ {value: undefined, disabled:true} ],
      nvState:[ {value: undefined, disabled:true} ],
      examinations:[ {value: undefined, disabled:true} ],
      hiTierState:[ {value: undefined, disabled:true} ],
      hiTierError:[ {value: undefined, disabled:true} ],
      hiTierErrorCode:[{value: undefined, disabled:true}], 
      nvError:[{value: undefined, disabled:true}],
      nvErrorCode:[{value: undefined, disabled:true}]
    })
    if (this.data.data) this.initializeWithData()
  }

  initializeWithData() {
    const {materialID, type, status, currentLocation, result, comment,nvState, examinations, hiTierState, hiTierError, hiTierErrorCode, nvError, nvErrorCode} = this.data.data
    const settType = this.dropdownType?.find(el => el.identifier == type)
    const settLocation = this.dropdownLocation?.find(el => el.identifier == currentLocation)
    const settStatus = this.dropdownStatus?.find(el => el.identifier == status)

    this.labSampleForm.patchValue({
      materialID, type: settType, status: settStatus, currentLocation: settLocation, result, comment, nvState,
      examinations:removeUndefined(examinations), hiTierState, hiTierError, hiTierErrorCode, nvError, nvErrorCode
    })
  }

  getTimeFirebaseTimestamp(date){
    return getTimeFirebaseTimestamp(date)
  }
  
  onSubmit() {
    if (!this.data.data) return 
    this.data.data?.setFromAny(this.labSampleForm.value)
    this.submit.emit()
  }
}